export const focusColor={
    "monochrome":"#323232",
    "brand":"#0078D4",
    "lightblue":"#DEECF9",
    "grey":"#F2F2F2"
}